import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const legacyPinRoute: InvariantJiraRoute = {
	name: 'legacy-pin',
	path: '/projects/:projectKey/issues/:issueKey?',
};
